module.exports = __webpack_public_path__ + "static/img/anhui.6a257a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/screen28896/influence-zone/anhui.png
// module id = 1NQS
// module chunks = 1